export const data = [
    // { "position": 1, "codigo": 'MIC', "institucion": 'Academia Militar General Miguel Iturralde Chillogallo' },
    // { "position": 2, "codigo": 'MIT', "institucion": 'Academia Militar General Miguel Iturralde Tumbaco' },
    { "position": 3, "codigo": 'DB', "institucion": 'Colegio Unidad Educativa Fiscomisional Don Bosco De La Tola' },
    { "position": 4, "codigo": 'F', "institucion": 'Unidad Educativa Cardenal Spellman Femenino' },
    { "position": 5, "codigo": 'SG', "institucion": 'Unidad Educativa Colegio San Gabriel' },
    { "position": 6, "codigo": 'MA', "institucion": 'Unidad Educativa Particular Maria Auxiliadora' },
    // { "position": 7, "codigo": 'F', "institucion": 'Unidad Educativa Mercedaria San Pedro Pascual' },
    { "position": 8, "codigo": 'LM', "institucion": 'Unidad Educativa Liceo Matovelle' },
    { "position": 9, "codigo": 'MZ', "institucion": 'Unidad Educativa Santa María Mazzarello' },
    { "position": 10, "codigo": 'C', "institucion": 'Unidad Educativa Salesiana Cardenal Spellman/Cumbaya' },

  ];